import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './Article.module.scss';
import qs from 'query-string';

const Article = (props) => {

  const location = useLocation();
  const navigate = useNavigate();
  const params = qs.parse(location.search);

  const articleView = () => {
    const _params = {
      ...params,
      command:'view',
      rootCategory : props.info.rootCategory,
      boardId : props.info.boardId,
      articleId : props.info.articleId
    }
    
    navigate(location.pathname + '?' + qs.stringify(_params));
  }

  const displayReplyCount = () => {
    if (props.info.replyCount > 0){
      return `[${props.info.replyCount}]`;
    }
  }

  const displayNew = () => {
    const now = new Date();
    const writeDate = new Date(props.info.writeDate);

    const diff = Math.abs((now - writeDate)/86400000);
    if (diff <= 1){
      return 'new';
    }
  }

  return (
    <tr className={styles.wrapper_article} onClick={articleView}>
      <td>{props.info.index}</td>
      <td style={{textAlign:'left'}}>{props.info.title}
      <span className={styles.reply}>{displayReplyCount()}</span>
      <span className={styles.new}>{displayNew()}</span>
      </td>
      <td>{props.info.writer}</td>
      <td>{props.info.writeDate.substring(0, 10)}</td>
      <td>{props.info.viewCount}</td>
      <td>{props.info.likeCount}</td>
    </tr>
  )
}

export default Article